/**
 * @fileoverview GET handler for the "/app_settings/message_activity_messages" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsMessageActivityMessages } from "./constants";
import type { AppSettingsMessageActivityMessagesParams, AppSettingsMessageActivityMessagesResult } from "./types";

export const getDataTableAppSettingsMessageActivityMessages = reactQueryTableFetcherAdapter(
  appSettingsMessageActivityMessages,
  (
    signal: AbortSignal,
    {
      appGroupId,
      campaignId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppSettingsMessageActivityMessagesParams
  ): Promise<AppSettingsMessageActivityMessagesResult> => {
    // Unfortunately query needs to be shaped here a bit. We used { type:
    // Array<MessageTypes> } since it works better with DataTable, but the
    // backend actually takes { [K in MessageTypes]: boolean }. We do that
    // remapping here.
    const actualQuery: Record<string, boolean> = {};
    if (query) {
      const { type } = query;
      for (const v of type) {
        actualQuery[v] = true;
      }
    }
    return fetch(
      "/app_settings/message_activity_messages",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        campaign_id: campaignId,
        query: serializeQueryObjects(actualQuery),
      },
      { signal }
    );
  }
);
